<template>
    <div class="events container-fluid mx-auto" :class="mode">
        <div class="row no-gutters overflow-hidden">
            <EventList></EventList>
            <EventContainer></EventContainer>
        </div>
    </div>
</template>

<script>
import EventList from '../components/event/EventList.vue';
import EventContainer from '../components/event/EventContainer.vue';

export default {
    name: 'events',
    async created() {
        await this.$store.dispatch('fetchEvents');
    },
    computed: {
        events() {
            return this.$store.state.events.list;
        },
        isLoading() {
            return this.$store.state.events.loading;
        },
        mode() {
            const query = this.$route.query;
            if (query.mode) return query.mode;
            if (query.id) return 'selected';
            return '';
        },
    },
    components: {
        EventList,
        EventContainer,
    },
};
</script>

<style lang="scss">
.events {
    max-width: 1200px;
    height: calc(100% - 60px);

    > .row {
        height: 100%;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    .event-controls {
        padding-bottom: 10px;
        border-bottom: 1px solid #aaa;
        margin-bottom: 10px;
    }

    @media (max-width: 991px) {
        &.container-fluid {
            padding: 0;
        }

        .eventdetail {
            display: none;
        }

        &.selected, &.scan, &.edit {
            .eventlist {
                display: none;
            }

            .eventdetail {
                display: block;
            }
        }
    }
}
</style>

